import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "block text-sm font-medium leading-6 text-gray-900" }
const _hoisted_3 = { class: "mt-2 relative" }
const _hoisted_4 = { class: "block w-full rounded-md border-0 py-1.5 pl-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 sm:max-w sm:text-sm sm:leading-6 outline-none cursor-pointer" }
const _hoisted_5 = { class: "absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" }
const _hoisted_6 = {
  key: 0,
  class: "absolute mt-1 z-30 w-full rounded-md bg-white shadow-lg border border-gray-300 overflow-auto max-h-48"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}

import { ref, onMounted, onBeforeUnmount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
  options: {
    type: Array as () => string[],
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Select Option',
  },
  label: {
    type: String,
  },
  errorMessage: String
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const showDropdown = ref<boolean>(false);
const dropdown = ref<HTMLElement | null>(null);
  
const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
}

const selectOption = (option: string) => {
  emit('update:modelValue', option)
  showDropdown.value = false;
}

const handleClickOutside = (event: MouseEvent) => {
  if (dropdown.value && !dropdown.value.contains(event.target as HTMLElement)) {
    showDropdown.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "relative dropdown",
        onClick: _withModifiers(toggleDropdown, ["stop"]),
        ref_key: "dropdown",
        ref: dropdown
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.modelValue || __props.placeholder), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            class: _normalizeClass(["transition-transform", { 'rotate-180': showDropdown.value }]),
            src: "/img/Icons/Arrow_Down.svg",
            alt: "Arrow Down"
          }, null, 2)
        ]),
        (showDropdown.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  onClick: _withModifiers(($event: any) => (selectOption(option)), ["stop"]),
                  class: "py-2 px-4 cursor-pointer hover:bg-gray-100"
                }, _toDisplayString(option), 9, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512),
      (__props.errorMessage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})